export enum RedemptionBrandVendorTypeEnum {
    TangoAPI = 'Tango API',
    ReportFile = 'Report/File'
}
